import { Text, VStack } from "@chakra-ui/layout";
import { Box } from "@chakra-ui/react";

import { UUID } from "foundation-ts/types";
import { $count, $isuuid, $ok } from "foundation-ts/commons";
import { SessionDto, UserDto } from "doxecure-commons/lib/doxecureClientTypes";
import { UserProfile } from "doxecure-commons/lib/doxecureTypes";

import { ColumnTitle } from "@components/ColumnTitle/ColumnTitle";
import { G1Button } from "@components/G1Button";
import { config } from "@/config/config";
import { SignatureBox } from "@containers/signature/SignatureBox";
import { $g1Color } from "@/theme/G1Style";
import { NeededPersonRole } from "@utils/TypesAndConstants";


// TODO: do we keep openFailModal here ?
interface TemplateSessionCreationPanelProps {
    session: SessionDto;
    userProfile: UserDto;
    optionAddApproversSwitchChecked?: boolean;
    optionInvisibleSwitchChecked?: boolean;
    optionOneToManyModeSwitchChecked?: boolean;
    onAddUser: (role: NeededPersonRole) => void;
    onChangeSession: (oldSession:SessionDto, newSession:SessionDto) => void;
    onRemoveUser: (apid: UUID, role: NeededPersonRole) => void;
    onSaveTemplate: () => void;
    onToggleAddApproversSwitch: () => void;
    onToggleInvisibleSwitch: () => void;
    onToggleOneToManyModeSwitch: () => void;
}

export const TemplateSessionCreationPanel = (props: TemplateSessionCreationPanelProps) => {
    const { session, userProfile, optionAddApproversSwitchChecked, optionInvisibleSwitchChecked, optionOneToManyModeSwitchChecked, onAddUser, onChangeSession, onRemoveUser, onSaveTemplate, onToggleAddApproversSwitch, onToggleInvisibleSwitch, onToggleOneToManyModeSwitch } = props;
    const isSessionValid = $isuuid(session.expeditor.apid) && $count(session.signatures) > 0 && session.title.length > 0 ;
    return (
        <>
            <ColumnTitle color={$g1Color('global.write')}>
                <Text>Création / Edition d'un modèle</Text>
            </ColumnTitle>

            <VStack spacing="5">
                <SignatureBox
                    session={session}
                    displayDuringTime={true}
                    enableAddApproversOption={config.app.nbMaxApprovers !== 0 && (userProfile.userFlags?.profile === UserProfile.AdministratorCorporate || userProfile.userFlags?.profile === UserProfile.UserCorporate)}
                    optionAddApproversSwitchChecked={optionAddApproversSwitchChecked}
                    optionInvisibleSwitchChecked={optionInvisibleSwitchChecked}
                    optionOneToManyModeSwitchChecked={optionOneToManyModeSwitchChecked}
                    onAddUser={onAddUser}
                    onRemoveUser={onRemoveUser}
                    onChangeSession={onChangeSession}
                    onToggleAddApproversSwitch={onToggleAddApproversSwitch}
                    onToggleInvisibleSwitch={onToggleInvisibleSwitch}
                    onToggleOneToManyModeSwitch={onToggleOneToManyModeSwitch}
                />
                <Box display="flex" flexDirection={{ base: "column", sm: "row" }} width="100%" gap="10px" justifyContent="center">
                    <G1Button component="form" variant="important" title={$ok(session.apid) ? 'Mettre à jour' : 'Créer'} width={{ base: "100%", sm: "30%" }} height="60px" marginLeft={{ base: "unset", sm: "2%" }} rounded="xl" fontSize="lg" disabled={!isSessionValid} onClick={onSaveTemplate} />
                </Box>
            </VStack>
        </>
    );
};